import { lsLoad } from '../../tools/Storage';
import StorageEnum from '../../enums/Storage.enum';
import { useEffect } from 'react';
import { getDefaultLanguageCode } from '../../tools/ConfigurationReader.ts';

export const useAppController = () => {
  const token = lsLoad(StorageEnum.Jwt);
  const languageCode = lsLoad(StorageEnum.UserProfile)?.languageCode;

  useEffect(() => {
    document.documentElement.lang = languageCode ?? getDefaultLanguageCode();
  }, [languageCode]);

  return {
    token,
  };
};
